/**
 * Entry point for the self-contained element build (`vite.element.config.ts`).
 *
 * Importing this module registers the custom element as a side effect, which is
 * what makes `<script src="fp-document-workspace.js">` work with no
 * further host code. The React entry (`src/index.ts`) deliberately does NOT do
 * this — React consumers opt in by calling `defineDocumentWorkspace()`.
 */
import '../styles.css';
import 'katex/dist/katex.min.css';
// prosemirror-view injects this stylesheet into `view.root` on first access.
// TipTap's useEditor() constructs the editor before EditorContent attaches it
// into our shadow tree, so `root` resolves to `document` and is cached there --
// leaving the editor inside the shadow root completely unstyled. Bundling the
// stylesheet into the shadow root's own CSS is what actually fixes that.
import 'prosemirror-view/style/prosemirror.css';
import { defineDocumentWorkspace } from './defineDocumentWorkspace';

defineDocumentWorkspace();

export { defineDocumentWorkspace };
export { DocumentWorkspaceElement } from './DocumentWorkspaceElement';
export { TAG_NAME } from '../constants/element';
export type {
  ResolveHref,
  TextClickedDetail,
  TextSelectedDetail,
} from '../types/element';
